import React from "react";
import { Box, Button, Stack, ThemeProvider, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import theme from "../Styles/theme";
import "../Styles/headerfooter.css";
import { useAuth } from "../Context/authContext";
import BackButton from "./backButton";
import { useLocation } from "react-router-dom";
import CollapsibleSideMenu from "./sideMenu";

const config = require("../Config/config");

export default function Header() {
  const { user } = useAuth();

  const handleLogoutClick = () => {
    window.location.href = `${config.serverBaseUrl}/auth/azuread/logout`;
  };
  const location = useLocation();
  return (
    <ThemeProvider theme={theme}>
      <Box className="header">
        <CollapsibleSideMenu></CollapsibleSideMenu>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            width: "100%",
            maxHeight: "100px",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100px",
            }}
          >
            {location.pathname !== "/" && location.pathname !== "/login" && (
              <BackButton></BackButton>
            )}
            <a href="/">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "100px",
                  width: "140px",
                }}
              >
                <Box
                  component="img"
                  src={
                    require("../Media/EBS_MONOGRAM_LOGO_WHITE_RGB.svg").default
                  }
                  alt="EBS logo"
                  className="logo"
                />
                {/* <Typography variant="title">Projects</Typography> */}
              </Box>
            </a>
          </Box>
          {user && (
            <Stack
              direction="row"
              className="header-nav"
              sx={{
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
            >
              <Button
                size="large"
                endIcon={<AddIcon />}
                variant="headerNav"
                color="primary"
                href="/project/new"
              >
                New Project
              </Button>
              {user.userData.userRoles.includes("Administrator") && (
                <Button variant="headerNav" color="primary" href="/dashboard">
                  Admin
                </Button>
              )}
              {(user.userData.userRoles.includes("Administrator") ||
                user.userData.userRoles.includes("Accounting")) && (
                <Button variant="headerNav" color="primary" href="/accounting">
                  Accounting
                </Button>
              )}
            </Stack>
          )}
          <Box
            width="auto"
            justifyContent="flex-end"
            sx={{
              display: user ? "flex" : "none",
              px: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              {user && (
                <Box
                  sx={{
                    display: {
                      xs: "none", // hide on extra-small screens
                      sm: "block", // show on small and up
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        sm: "0.7rem", // tablets
                        md: "0.9rem", // desktops
                      },
                    }}
                  >
                    Logged in as:
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        sm: "0.7rem", // tablets
                        md: "0.9rem", // desktops
                      },
                    }}
                  >
                    {user?.userData.name}
                    <br></br> (
                    {user?.userData.userRoles.reduce(
                      (prev, curr) =>
                        prev === "Administrator" || curr === "Administrator"
                          ? "Administrator"
                          : prev === "Accounting" || curr === "Accounting"
                            ? "Accounting"
                            : prev === "Unit Manager" || curr === "Unit Manager"
                              ? "Unit Manager"
                              : prev === "Standard User" ||
                                  curr === "Standard User"
                                ? "Standard User"
                                : undefined,
                      undefined,
                    )}
                    )
                  </Typography>
                </Box>
              )}
            </Box>

            <Button variant="login" onClick={handleLogoutClick}>
              Logout
            </Button>
          </Box>
        </Stack>
      </Box>
    </ThemeProvider>
  );
}
